'use client';
import { deepmergeCustom } from '../../../../node_modules/deepmerge-ts/dist/index.js';

const mergeArraysByIndex = (e, r)=>{
    var t;
    let n = [
        ...null !== (t = e[0]) && void 0 !== t ? t : []
    ];
    for(let t = 1; t < e.length; t++)e[t].forEach((e, t)=>{
        n[t] = r.deepmerge(n[t], e);
    });
    return n;
};
function merge(r) {
    return deepmergeCustom({
        mergeArrays: mergeArraysByIndex
    })(...r);
}

export { merge, mergeArraysByIndex };
